// FIXME (maybe): jspc screaming for duplication of imports which hinders we make the code cleaner
// jscpd:ignore-start
import classNames from 'classnames';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { preferenceActions } from '../../../actions';
import useDispatch from '../../../hooks/useDispatch';
import { usePreferences } from '../../../hooks/usePreferences';
import {
  DL_SWITCH_CLASS_NAME,
  DL_SWITCH_LEAD_CLASS_NAME,
  DL_SWITCH_LINE_WRAPPER_CLASS_NAME,
} from '../PriceViewer';
// jscpd:ignore-end

const ChartUnitSwitch: React.FC<{
  wrapAnalytics: (dataKey: string, callback: () => void) => () => void;
  stockCode: string;
}> = ({ wrapAnalytics, stockCode }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { unit } = usePreferences();
  const unit_list = ['minute', 'd', 'w', 'm'];
  if (stockCode.startsWith('^')) {
    unit_list.shift();
  }
  return (
    <>
      <div className={DL_SWITCH_LINE_WRAPPER_CLASS_NAME}>
        {unit_list.map((theUnit, i) => {
          const button = (
            <div
              key={`unit-${theUnit}`}
              className={classNames(DL_SWITCH_CLASS_NAME, {
                [DL_SWITCH_LEAD_CLASS_NAME]: i === 0,
                checked: unit === theUnit,
              })}
              onClick={wrapAnalytics(`unit-${theUnit}`, () =>
                dispatch(preferenceActions.setPriceViewerUnit(theUnit))
              )}
            >
              {t(`unit-${theUnit}`)}
            </div>
          );
          return theUnit === 'minute' ? (
            <OverlayTrigger
              key={`unit-${theUnit}`}
              placement="auto-start"
              overlay={
                <Tooltip id="multi-explain">
                  {t('minute-update-explain')}
                </Tooltip>
              }
            >
              {button}
            </OverlayTrigger>
          ) : (
            button
          );
        })}
      </div>
    </>
  );
};

export default ChartUnitSwitch;
